"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { OneTrust } from "./OneTrust/index.js";
import { TranscendAirgap } from "./TranscendAirgap/index.js";
import { COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_KEY, COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_VALUE_ON } from "../constants.js";
import { useSessionStorage } from "../../../hooks/useSessionStorage/index.js";
function ConsentScriptsClient({
  isTranscendEnabled,
  isTranscendOverridesEnabled,
  transcendConfig,
  oneTrustConfig
}) {
  const [consentProviderSessionStorage] = useSessionStorage(
    COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_KEY,
    isTranscendEnabled
  );
  isTranscendEnabled = isTranscendEnabled || consentProviderSessionStorage === COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_VALUE_ON;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      TranscendAirgap,
      {
        transcendConfig,
        isTranscendEnabled,
        isTranscendOverridesEnabled
      }
    ),
    /* @__PURE__ */ jsx(
      OneTrust,
      {
        oneTrustConfig,
        isTranscendEnabled
      }
    )
  ] });
}
export {
  ConsentScriptsClient
};
